import Api from '@/providers/Api'
import User from '@/User'
import router from '@/router/router'

/**
 * A simple authorization service for the router, as well as for general use throughout the app.
 *
 * In the router, each route that has authorization restrictions should provide a security rule
 * as part of its meta, e.g.:
 *
 *      meta: {
 *          ...
 *          security: (auth) => auth.isSuperAdmin()
 *      }
 *
 * The security function can use any of the helper functions defined on this service
 * (e.g. to AND/OR conditions); if it returns false, navigation is aborted.
 *
 * If a router security rule requires access to a route param, such as a company ID,
 * it must access it through the auth.to variable, which is provided for convenience - e.g.:
 *
 *     security: (auth) => auth.isCompanyAdmin(auth.to.params.companyId)
 *
 * When used in the router, helper functions that require async calls to the API will
 * initially allow navigation, but trigger an error and undo navigation if the API call
 * comes back negative.
 *
 * Authorization methods or helpers can also be used independently of the router, e.g. to
 * show/hide or enable/disable links or buttons. If an authorization method requires access
 * to a complex object, such as a SurveyNote, that is not readily accessible from the current
 * user state, it must declare that object as an argument, and it will generally not be
 * suitable for use with the router.
 */


export default {
    // params (make these object-level so we don't have to pass them around in function calls)
    to: null,
    from: null,
    next: null,

    // helper functions (application-specific)

    isSuperAdmin () {
        return User.isSuperAdmin()
    },

    isAdmin () {
        return User.isAdmin()
    },

    isAdminPromise () {
        return Promise.resolve(User.isSuperAdmin() || User.isAdmin())
    },

    isProgramAdminOrAdminPromise () {
        return Promise.resolve(User.isSuperAdmin() || User.isProgramAdmin() || User.isAdmin())
    },

    // isCompanyAdmin(companyId) {
    //     return User.isCompanyAdmin(companyId)
    // },

    async can (args) {
        //  convert arg
        if (args.arg) {
            args.args = [args.arg]
            delete args.arg
        }
        // TODO: add caching
        return Api.can(args)
            .then((response) => response.json())
            .then((json) => {
                return json
            })
    },

//
// belongsToCompany(companyId) {
//     return User.belongsToCompany(companyId)
// },
//
// belongsToAgency(agencyId) {
//     return User.belongsToAgency(agencyId)
// },
//
// canViewEquipment(equipmentId) {
//     Api.getItem(null, 'equipment', equipmentId, []).then(item => {
//         if (!item) {
//             this.authError('Unauthorized')
//         }
//     })
//     return true
// },
//
// async canCreateAttachment(modelName, modelId) {
//     return await Api.canCreateAttachment(modelName, modelId);
// },
//
// async canEditAttachment(attachmentId) {
//     return await Api.canEditAttachment(attachmentId);
// },

    // display an error message and block/undo navigation

    authError (msg) {
        router.app.$toasted.error(msg)
        this.next(this.from)
    }

}
